import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from 'core/query/queryKeys';
import type { Order } from 'types/delivery.types';
import type { OrderRealtimeEvent } from 'types/tracking.types';

export function handleOrderRealtimeEvent(
  event: OrderRealtimeEvent,
  queryClient: QueryClient,
): void {
  const { orderId } = event.payload;

  if (event.type === 'order.updated') {
    void queryClient.invalidateQueries({
      queryKey: queryKeys.orders.detail(orderId),
    });
    return;
  }

  if (event.type === 'order.location.updated') {
    const { lat, lng, updatedAt, heading, speed, vehicle } = event.payload;
    queryClient.setQueryData<Order>(queryKeys.orders.detail(orderId), (old: Order | undefined) =>
      old
        ? {
            ...old,
            ...(vehicle ? { vehicle } : {}),
            driverLocation: {
              lat,
              lng,
              updatedAt,
              ...(heading != null ? { heading } : {}),
              ...(speed != null ? { speed } : {}),
            },
          }
        : old,
    );
  }
}
